import { useParams } from "react-router-dom";
import Status2MessageTable from "./Status2MessageTable";
import Status1MessageTable from "./Status1MessageTable";
import Status4MessageTable from "./Status4MessageTable";
import StatusOtherMessageTable from "./StatusOtherMessageTable";
import styles from "./index.module.less";

function ProcessMessage() {
  const { statusType } = useParams();

  let Component;
  if (statusType === "1") {
    Component = Status1MessageTable;
  } else if (statusType === "2") {
    Component = Status2MessageTable;
  } else if (statusType === "4") {
    Component = Status4MessageTable;
  } else {
    Component = StatusOtherMessageTable;
  }
  return (
    <div className={styles.processMessage}>
      <Component />
    </div>
  );
}

export default ProcessMessage;
